/* eslint-disable */


import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import TopBar from "../../common/TopBar";
import './FileBoard.css';


export default function FileBoard() {
  const navigate = useNavigate();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
     listDownloadBoard();
  }, []);

  const topHeader = {
    title: '파일 게시판',
    leftIcon: '/images/totp/ui/left.png',
  };

  const handleGoLinkHome = () => {
    navigate('/vtotp/otp-list');
  };

  const listDownloadBoard = async () => {
    const response = await fetch('https://api.github.com/repos/vanillayous/download-board/contents/', {
      method: 'GET',
      headers: {
        'Accept': 'application/vnd.github.v3+json',
      },
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || '파일 게시판을 불러오는데 실패했습니다');
    }
    const list = await response.json();
    setFileList(list);
  };

  const formatSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  };

  const files = fileList.filter((f) => f.type === 'file');

  return (
    <div className="page-wrapper">
      <TopBar topHeader={topHeader} onLeftClick={handleGoLinkHome} />
      <div className="page-content">
        <div className="file-board-container">
          {files.length === 0 ? (
            <p className="file-board-empty">파일을 불러오는 중...</p>
          ) : (
            files.map((file) => (
              <div key={file.name} className="file-board-item">
                <span className="file-board-name">{file.name}</span>
                <span className="file-board-size">{formatSize(file.size)}</span>
                <a
                  href={file.download_url}
                  className="file-board-download"
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  다운로드
                </a>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );

}
